
import common from '@/tools/common'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

export default {
components: {
Grid,
GridItem,
GroupTitle,
XInput,
Group,
Cell,
Search,
XButton,
Flexbox,
Card,
FlexboxItem
},
methods: {
},
data () {
return {
GridData: [
{text: '通关指南', link: '/CustomsGuide', Querydata: ['SPXX0012'], icon: '通关指南.png'},
{text: '进口关税', link: '/ImportTariff', Querydata: ['SPXX0001'], icon: '进口关税.png'},
{text: '出口关税', link: '/ExportTax', Querydata: ['SPXX0003'], icon: '出口关税.png'},
{text: '代征税', link: '/ImportLinkageTax', Querydata: ['SPXX0002'], icon: '代征税.png'},
{text: '出口退税', link: '/ExportRebates', Querydata: ['SPXX0004'], icon: '出口退税.png'},
{text: '反倾反补', link: '/HandBookAntiDumping', icon: '反倾反补.png'},
{text: '进境物品', link: '/EntryGoods', icon: '进境物品.png'},
{text: '计量单位', link: '/G_Unit', icon: '计量单位.png'}
]
}
},
beforeCreate: function () {
this.querydata = common.getPower()
},
activated: function () {
console.log(this.GridData)













},
mounted () {
common.alertOnceInnerTitle(this, '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;本系统为图书增值服务而设，所提供的资料和服务仅供参考，用户应以实际通关、办理海关手续时相关海关的解释和要求为准，对用户使用本系统提供的资料和服务可能存在的风险由用户本人承担。', '提示', '1')
},
created: function () {
}
}



// WEBPACK FOOTER //
// ./src/components/GoodsInfo.vue